import { Table, Text } from "melco-ui";
import { useGetCategories } from "../../hooks/categories/useGetCategories"
import { useAddRemoveCategory } from "../../hooks/hoops/useAddRemoveCategory";
import { useTranslation } from "react-i18next";
import { Key } from "react";


export const HoopCategoryList: React.FC = () => {
    const { t } = useTranslation();
    const { data } = useGetCategories();
    const { categories, addCategories, removeCategories } = useAddRemoveCategory();

    // controlled selection from Formik
    const selectedRowKeys: Key[] = (categories ?? []).map((c: any) =>
        String(c.id)
    );

    // selectedRowKeys: array of selected IDs (Key[])
    const selectedCount = selectedRowKeys.length;

    const handleSelectionChange = (newSelectedKeys: Key[]) => {
        const currentIds = selectedRowKeys.map(String);
        const newIds = newSelectedKeys.map(String);

        const addedIds = newIds.filter((k) => !currentIds.includes(k));
        const removedIds = currentIds.filter((k) => !newIds.includes(k));

        const categoriesToAdd = (data ?? []).filter((c: any) =>
            addedIds.includes(String(c.id))
        );

        const categoriesToRemove = removedIds.map((id) => ({
            id: String(id)
        }));

        if (categoriesToAdd.length) addCategories(categoriesToAdd);
        if (categoriesToRemove.length) removeCategories(categoriesToRemove);
    };

    const columns = [


        {
            title: t("managehoops.tabs.categories.table.columns.asset_url"),
            // dataIndex: "asset_url",
            key: "asset_url",
            render: (rowObj: any) => (<><img height={100} width={100} alt={`${rowObj?.name ?? "img "} icon`} src={rowObj?.asset_url} /> </>),
            width: 150
        },
        {
            title: t("managehoops.tabs.categories.table.columns.name"),
            // dataIndex: "asset_url",
            key: "asset_url",
            render: (rowObj: any) => (<> {rowObj?.name}</>)
        }

    ];

    return (
        <>
            {/* Selected count text */}
            {selectedCount > 0 && (
                <div style={{ marginBottom: 1, textAlign: "right" }}>
                    <Text >{selectedCount} {t("managehoops.tabs.categories.selected_categories")}</Text>
                </div>
            )}
            <Table
                dataSource={data}
                columns={columns}
                rowKey={(record) => String(record.id)} //  fix type issue
                rowSelection={{
                    selectedRowKeys,
                    onChange: handleSelectionChange,

                    //  VERY IMPORTANT for pagination
                    preserveSelectedRowKeys: true,

                    //dropdown (Select All / Invert / None)
                    selections: true
                }}

                //  same as before (pagination ON)
                pagination={{
                    pageSize: 10
                }}
            />
        </>
    );
};

